// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $dot$dot$slash$dot$dot$slash$dot$dot$slash = require("../../../");

var make = $dot$dot$slash$dot$dot$slash$dot$dot$slash.Label;

exports.make = make;
/* make Not a pure module */
